import React, { useState } from "react"
import { createUseStyles, useTheme } from "react-jss"
import {
  SCREENS_DETAILS,
  maxWidth,
  minWidth,
  monthOptions,
  yearOptions,
} from "../../util/StaticData"
import SingleSelection from "../../components/Filters/SingleSelection"
import { useEffect } from "react"
import {
  marketSingleFilterOptionsAsync,
  marketSingleSelectionFilterChange,
  marketSinleFilterOptionsSelector,
  marketSinleSelectedValueSelector,
  monthFilterChange,
  pipeLineFilterChange,
  pipeLineFilterOptionsSelector,
  pipeLineNameFilterChange,
  pipeLineSelectedValueSelector,
  runIdChange,
  useCaseFilterChange,
  filterUseCaseOptionsAsync,
  useCaseFilterOptionsSelector,
  useCaseSelectedValueSelector,
  yearFilterChange,
} from "./FilterSlice"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import {
  cardToggle,
  gantChartAsync,
  monthFilterChangeMonitor,
  pipelineCardsAsync,
  yearFilterChangeMonitor,
} from "./MonitorSlice"
import { useLocation, useSearchParams } from "react-router-dom"
import { ReactDatePicker } from "../../components/ReactDatePicker"
import {
  getCurrentParamsInObj,
  setCurrentScreenVal,
} from "../../util/CommonMethods"

const useStyles = createUseStyles({
  filterContainer: {
    display: "flex",
  },
  filterLabel: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    marginRight: 10,
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
  },
})
function FilterGroup() {
  const location = useLocation()
  const [currentScreen, setCurrentScreen] = useState("")
  const dispatch = useAppDispatch()
  const useCaseOptions = useAppSelector(useCaseFilterOptionsSelector)
  const marketSingleOptions = useAppSelector(marketSinleFilterOptionsSelector)

  const useCaseSelectedValue = useAppSelector(useCaseSelectedValueSelector)

  const marketSingleSelectedValue = useAppSelector(
    marketSinleSelectedValueSelector,
  )
  const pipeLineSelectedValue = useAppSelector(pipeLineSelectedValueSelector)
  const pipeLineOptions = useAppSelector(pipeLineFilterOptionsSelector)
  const runIdOptionsData = useAppSelector(
    (state) => state.filters.runIdOptionsData,
  )
  const runIdSelectedValue = useAppSelector(
    (state) => state.filters.runIdSelectedValue,
  )

  const monthSelectedValue = useAppSelector(
    (store) => store.filters.monthSelectedValue,
  )

  const yearSelectedValue = useAppSelector(
    (store) => store.filters.yearSelectedValue,
  )
  const pipeLineNamesAndRunIdsRawData = useAppSelector(
    (store) => store.filters.pipeLineNamesAndRunIdsRawData,
  )

  useEffect(() => {
    if (pipeLineOptions?.length && runIdSelectedValue) {
      const temp: any = pipeLineNamesAndRunIdsRawData.find((obj: any) => {
        return obj["az_pipeline_run_ids"].filter(
          (o: any) => o.az_pipeline_run_id === runIdSelectedValue,
        ).length
      })
      if (temp) {
        dispatch(pipeLineFilterChange(temp.pipeline_name))
        dispatch(runIdChange(runIdSelectedValue))
        dispatch(pipeLineNameFilterChange())
      }
    }
  }, [pipeLineOptions, dispatch])

  const defaultCalls = async () => {
    if (
      currentScreen === SCREENS_DETAILS.MONITORING ||
      currentScreen === SCREENS_DETAILS.DATA_METADATA ||
      currentScreen === SCREENS_DETAILS.MODEL_META_DATA ||
      currentScreen === SCREENS_DETAILS.MAINTENANCE
    ) {
      if (useCaseOptions.length === 0) {
        dispatch(filterUseCaseOptionsAsync())
      }
      if (marketSingleOptions.length === 0) {
        dispatch(marketSingleFilterOptionsAsync())
      }
    }
  }

  useEffect(() => {
    defaultCalls()
  }, [currentScreen])
  const updateData = () => {
    if (currentScreen === SCREENS_DETAILS.MONITORING) {
      dispatch(pipelineCardsAsync())
      dispatch(gantChartAsync())
    }
  }
  const [searchParams, setSearchParams] = useSearchParams()

  const singleRunIdChange = (value: any) => {
    dispatch(runIdChange(value))
    const tempParams: any = getCurrentParamsInObj(searchParams)
    setSearchParams({ ...tempParams, runId: value })
    updateData()
  }
  const monthChange = (value: string) => {
    dispatch(monthFilterChange(value))
    dispatch(monthFilterChangeMonitor(value))
    updateData()
  }
  const yearChange = (value: string) => {
    dispatch(yearFilterChange(value))
    dispatch(yearFilterChangeMonitor(value))
    updateData()
  }

  const useCaseChange = (value: string) => {
    dispatch(useCaseFilterChange(value))
    updateData()
  }
  const marketSingleFilterChange = (value: string) => {
    dispatch(marketSingleSelectionFilterChange(value))
    updateData()
  }
  const pipelineSingleFilterChange = (value: string) => {
    dispatch(pipeLineFilterChange(value)) // filter value update
    dispatch(pipeLineNameFilterChange()) // updates run ids filter options
    dispatch(runIdChange("")) // run id filter will be reset to empty.
    updateData()
  }

  const theme: any = useTheme()
  const classes = useStyles({ theme })
  useEffect(() => {
    setCurrentScreenVal(location, setCurrentScreen)
    dispatch(cardToggle("pipelines"))
  }, [location])

  useEffect(() => {
    if (
      currentScreen === SCREENS_DETAILS.MONITORING &&
      useCaseSelectedValue &&
      marketSingleSelectedValue
    ) {
      dispatch(gantChartAsync())
      dispatch(pipelineCardsAsync())
    }
  }, [useCaseSelectedValue, marketSingleSelectedValue, currentScreen])

  return (
    <div className={classes.filterContainer}>
      <SingleSelection
        minWidth={minWidth}
        maxWidth={maxWidth}
        changeFunc={useCaseChange}
        filterValue={useCaseSelectedValue}
        options={useCaseOptions}
        label="Use Case"
      />
      <div className={classes.filterWrapper}>
        <SingleSelection
          minWidth={minWidth}
          maxWidth={maxWidth}
          changeFunc={marketSingleFilterChange}
          filterValue={marketSingleSelectedValue}
          options={marketSingleOptions}
          label="Market"
        />
        {currentScreen === SCREENS_DETAILS.MAINTENANCE ? (
          <ReactDatePicker></ReactDatePicker>
        ) : (
          ""
        )}

        {currentScreen === SCREENS_DETAILS.DATA_METADATA ||
        currentScreen === SCREENS_DETAILS.MODEL_META_DATA ? (
          <>
            <ReactDatePicker></ReactDatePicker>
            <SingleSelection
              minWidth={260}
              maxWidth={300}
              changeFunc={pipelineSingleFilterChange}
              filterValue={pipeLineSelectedValue}
              options={pipeLineOptions}
              label="Pipeline Name"
              isSearchable={true}
            />
            <SingleSelection
              minWidth={220}
              maxWidth={240}
              changeFunc={singleRunIdChange}
              filterValue={runIdSelectedValue}
              options={runIdOptionsData}
              isSearchable={true}
              label="Pipeline Run ID"
            />
          </>
        ) : (
          ""
        )}
        {currentScreen === SCREENS_DETAILS.MAINTENANCE ? (
          <SingleSelection
            minWidth={300}
            maxWidth={300}
            changeFunc={pipelineSingleFilterChange}
            filterValue={pipeLineSelectedValue}
            options={pipeLineOptions}
            label="Pipeline Name"
            isSearchable={true}
          />
        ) : (
          ""
        )}
      </div>
      {currentScreen == SCREENS_DETAILS.MONITORING ? (
        <>
          <SingleSelection
            minWidth={120}
            maxWidth={140}
            changeFunc={monthChange}
            filterValue={monthSelectedValue}
            options={monthOptions}
            label="Month"
          />
          <SingleSelection
            minWidth={60}
            maxWidth={80}
            changeFunc={yearChange}
            filterValue={yearSelectedValue}
            options={yearOptions}
            label="Year"
          />
        </>
      ) : (
        ""
      )}
    </div>
  )
}

export default FilterGroup
